import CustomExportButton from 'components/CustomExportButton';
import { FC, cloneElement, ReactElement } from 'react';
import {
  ToolbarProps,
  ExportButtonProps,
  sanitizeListRestProps,
  useListContext,
  TopToolbar,
  CreateButton,
} from 'react-admin';

type CustomListProps = {
  hasCreate?: boolean;
};

type ListActionProps = ToolbarProps &
  CustomListProps &
  Pick<ExportButtonProps, 'maxResults'> & {
    filters?: ReactElement;
  };

export const CustomListActions: FC<ListActionProps> = props => {
  const { className, filters, maxResults, hasCreate = false, ...rest } = props;
  const {
    currentSort,
    resource,
    displayedFilters,
    filterValues,
    basePath,
    showFilter,
    total,
  } = useListContext();

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      {hasCreate && <CreateButton basePath={basePath} />}
      <CustomExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filterValues={filterValues}
        maxResults={maxResults}
      />
    </TopToolbar>
  );
};

export default CustomListActions;
